import { withInstall } from '@tav-ui/utils/with-install'
import TimeLine from './src/timeLine'
const TaTimeLine = withInstall(TimeLine)
export { TaTimeLine }
export default TaTimeLine
export * from './src/types'
